<template>
  <div class="system-maintenance">
    <img src="../assets/img/system.png" alt="">
    <p>系统维护中...</p>
  </div>
</template>

<script>
export default {
  name: 'systemMaintenance'
}
</script>

<style lang="less" scoped>
.system-maintenance {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: @fz32;
  color: #FF9600;
  background-color: #fff;
  overflow: hidden;
  img {
    width: 4.56rem;
    height: 2.77rem;
    padding-top: 3.56rem;
  }
  p {
    margin-top: -0.6rem;
  }

}
</style>
